export const HOME_FAQS = [
  {
    question: 'What does Valley International Supply do?',
    answer: 'We source and distribute industrial automation, electrical, pneumatic and control products, with technical guidance for manufacturers across the United States, Mexico and Central America.'
  },
  {
    question: 'Can you help identify or cross-reference an industrial part?',
    answer: 'Yes. Send us the manufacturer, part number, photos or application details. Our team can evaluate compatible products and practical alternatives for your requirement.'
  },
  {
    question: 'Which industrial automation brands do you supply?',
    answer: 'Our network includes Siemens, ABB, SICK, OMRON, SMC, Phoenix Contact, Balluff, Eaton, Norgren and many other established industrial manufacturers.'
  },
  {
    question: 'Do you serve customers outside the United States?',
    answer: 'Yes. Valley International Supply supports manufacturers across the Americas through regional teams in Brownsville, Texas; Matamoros, Mexico; and San Pedro Sula, Honduras.'
  },
  {
    question: 'How can I request pricing or technical assistance?',
    answer: 'Use our project inquiry form, email inquiry@valleyintlsupply.com or call +1 956-338-0631. Include the part number, brand, quantity and delivery location when available.'
  }
];

export const HOME_FAQS_ES = [
  {
    question: '¿Qué hace Valley International Supply?',
    answer: 'Suministramos y distribuimos productos de automatización industrial, eléctricos, neumáticos y de control, con orientación técnica para fabricantes en Estados Unidos, México y Centroamérica.'
  },
  {
    question: '¿Pueden ayudarme a identificar o encontrar un equivalente para una pieza industrial?',
    answer: 'Sí. Envíenos el fabricante, número de parte, fotografías o detalles de la aplicación. Nuestro equipo puede evaluar productos compatibles y alternativas prácticas para su necesidad.'
  },
  {
    question: '¿Qué marcas de automatización industrial suministran?',
    answer: 'Nuestra red incluye Siemens, ABB, SICK, OMRON, SMC, Phoenix Contact, Balluff, Eaton, Norgren y muchos otros fabricantes industriales reconocidos.'
  },
  {
    question: '¿Atienden a clientes fuera de Estados Unidos?',
    answer: 'Sí. Valley International Supply atiende a fabricantes en todo el continente americano mediante equipos regionales en Brownsville, Texas; Matamoros, México; y San Pedro Sula, Honduras.'
  },
  {
    question: '¿Cómo puedo solicitar precios o asistencia técnica?',
    answer: 'Use nuestro formulario de consulta, escriba a inquiry@valleyintlsupply.com o llame al +1 956-338-0631. Cuando sea posible, incluya el número de parte, la marca, la cantidad y el lugar de entrega.'
  }
];

export const getHomeFaqs = (language) => (language === 'es' ? HOME_FAQS_ES : HOME_FAQS);
